import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { register as registerThunk, clearAuthError } from 'store/slices/authSlice';
import AuthPage from 'components/layout/AuthPage/AuthPage';
import { PrimaryButton, Link } from 'components/buttons/';
import { createConfirmPasswordRegisterOptions } from 'components/forms/patterns';
import { EmailField, PasswordField } from 'components/forms';
import TimedRedirect from 'components/layout/TimedRedirect/TimedRedirect';

function Register() {
  const dispatch = useDispatch();
  const { loading, error, status } = useSelector((state) => state.auth);
  const { register, handleSubmit, watch, formState: { errors, isDirty } } = useForm({ mode: "onChange" });

  useEffect(() => {
    return () => { dispatch(clearAuthError()); };
  }, [dispatch]);

  const onSubmit = (data) => {
    const { email, password } = data;
    const { locale, timeZone: timezone } = Intl.DateTimeFormat().resolvedOptions();
    dispatch(registerThunk({ email, password, timezone, locale }));
  };

  const renderRegisterForm = () => (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <EmailField register={register} errors={errors} />
        <PasswordField register={register} errors={errors} />
        <PasswordField
          name="confirmPassword"
          register={register}
          errors={errors}
          registerOptions={createConfirmPasswordRegisterOptions(watch)}
          labelText='Confirm password'
          placeholder="Repeat Password"
        />

        <div>
          <PrimaryButton
            type="submit"
            disabled={loading || !isDirty}
            className="flex w-full justify-center"
          >
            {loading ? 'Submitting...' : 'Register'}
          </PrimaryButton>
        </div>
      </form>

      <p className="mt-10 text-center text-sm/6 text-gray-400">
        Are you a member?{' '}
        <Link to="/login">Login</Link>
      </p>
    </>
  );

  return (
    <AuthPage title="Create your account" error={error}>
      {
        status
        ? <TimedRedirect url="/login" message={status} delay={5000} />
        : renderRegisterForm()
      }
    </AuthPage>
  );
}

export default Register;
